/**
 * Multi-value input for `set_random` actions: MultiSelectWithTag with async search
 * (same UI/behavior as QueryBuilder multi-select condition values).
 */

import type { QueryBuilderConfig } from "../../../data-model/queryBuilder";
import MultiSelectWithTag from "../../multiSelectWithTag/MultiSelectWithTag";
import { toValueArray } from "./ruleFormConstants";
import { useActionValueSearch } from "./useActionValueSearch";

interface ActionSetRandomValueInputProps {
  /** Stable id prefix for the control (e.g. `action-values-0`). */
  id: string;
  /** Field label (e.g. "Values"). */
  label: string;
  conditionConfig: QueryBuilderConfig;
  selectedField: string;
  value: string | string[];
  onValuesChange: (values: string[]) => void;
  placeholder?: string;
}

/**
 * Multi-select MultiSelectWithTag for `set_random` action values.
 */
const ActionSetRandomValueInput = ({
  id,
  label,
  conditionConfig,
  selectedField,
  value,
  onValuesChange,
  placeholder = "Select value...",
}: ActionSetRandomValueInputProps) => {
  const selectedValues = toValueArray(value);
  const searchProps = useActionValueSearch(
    conditionConfig,
    selectedField,
    value,
  );

  return (
    <div className="flex flex-col gap-1">
      {label ? (
        <label
          htmlFor={id}
          className="text-tiny font-medium text-primaryGray-3"
        >
          {label}
        </label>
      ) : null}
      <div
        className={
          selectedField ? "w-full" : "pointer-events-none w-full opacity-50"
        }
      >
        <MultiSelectWithTag
          dropdownWidth="5rem"
          className="w-full"
          {...searchProps}
          value={selectedValues}
          onChange={onValuesChange}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default ActionSetRandomValueInput;
